import { Button, Space } from 'antd'
import React, { useState, Fragment, useImperativeHandle } from 'react'
import { Modal } from 'antd'
const Consult = (props) => {
  // 属性
  const [createModalVisible, handleModalVisible] = useState(false)

  // 用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      open
    }
  })

  const phoneStyle = {
    fontWeight: 'bold',
    color: '#1890ff',
    marginBottom: '10px'
  }

  const open = () => {
    handleModalVisible(true)
  }

  return (
    <Fragment>
      <Modal
        destroyOnClose
        centered
        title='提示'
        visible={createModalVisible}
        onCancel={() => handleModalVisible(false)}
        footer={null}
        style={{ textAlign: 'center' }}
        width={400}
      >
        <p style={{ marginBottom: '20px' }}>产品价格咨询,请联系:<span style={phoneStyle}>0574-86261037</span> </p>
        <Space>
          <Button type='primary' onClick={() => handleModalVisible(false)} >
                  关闭
          </Button>
        </Space>
      </Modal>
    </Fragment>
  )
}

export default Consult
